import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.css'],
    standalone: false
})
export class CardComponent implements OnInit {

  @Input() propiedades:[]=[];

  constructor() { }

  ngOnInit(): void {
  }

}
